import { TabItem, Tabs } from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";

import usePermissions from "hooks/usePermission";
import { RuleLogs, Rules } from ".";

const RulesTab = () => {
  const [canReadConfig, canRead] = usePermissions([
    "rule:read-config",
    "rule:read",
  ]);
  return (
    <Tabs>
      {canRead && (
        <TabItem title={strings.rules}>
          <div className="m-4">
            <RuleLogs />
          </div>
        </TabItem>
      )}
      {canReadConfig && (
        <TabItem title={strings.rulesConfig}>
          <div className="m-4">
            <Rules />
          </div>
        </TabItem>
      )}
    </Tabs>
  );
};

const strings = new LocalizedStrings({
  es: {
    rulesConfig: "Configuración de Reglas",
    rules: "Reglas",
  },
});

export default RulesTab;
